module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head_office":"本社"}}')
  delete Component.options._Ctor
}
